import React from 'react';
import { Instagram, Youtube } from 'lucide-react';
export function Footer() {
  const SHOP_URL = 'https://shop.purepulsepilates.com';
  const footerSections = [{
    title: 'Shop',
    links: ['New In', 'Leggings & Sets', 'Bras & Tops', 'Layers', 'Bestsellers'],
    href: SHOP_URL
  }, {
    title: 'Help',
    links: ['Shipping', 'Returns', 'Size Guide', 'FAQ', 'Contact'],
    href: '#'
  }, {
    title: 'About',
    links: ['Our Story', 'Journal', 'Sustainability'],
    href: '#'
  }];
  return <footer className="bg-espresso text-cream" data-id="element-54">
      <div className="max-w-7xl mx-auto px-6 py-16 md:py-24" data-id="element-55">
        <div className="mb-12 text-center lg:text-left" data-id="element-56">
          <img src="https://cdn.magicpatterns.com/uploads/jwuPFHfY8i8vKyYQKsjz7s/pure-pulse-logo.png" alt="Pure Pulse Club" className="h-10 mx-auto lg:mx-0 mb-12 brightness-0 invert" data-id="element-57" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-58">
          {footerSections.map(section => <div key={section.title} data-id="element-59">
              <h3 className="uppercase tracking-widest text-sm mb-4" data-id="element-60">
                {section.title}
              </h3>
              <ul className="space-y-3" data-id="element-61">
                {section.links.map(link => <li key={link} data-id="element-62">
                    <a href={section.href} className="text-cream/70 hover:text-cream transition-colors" data-id="element-63">
                      {link}
                    </a>
                  </li>)}
              </ul>
            </div>)}

          <div data-id="element-64">
            <h3 className="uppercase tracking-widest text-sm mb-4" data-id="element-65">
              Stay Connected
            </h3>
            <p className="text-cream/70 mb-4" data-id="element-66">
              Follow us for inspiration and updates.
            </p>
            <div className="flex gap-4" data-id="element-67">
              <a href="#" className="hover:text-rust transition-colors" aria-label="Instagram" data-id="element-68">
                <Instagram size={24} data-id="element-69" />
              </a>
              <a href="#" className="hover:text-rust transition-colors" aria-label="TikTok" data-id="element-70">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" data-id="element-71">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-72" />
                </svg>
              </a>
              <a href="#" className="hover:text-rust transition-colors" aria-label="Pinterest" data-id="element-73">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" data-id="element-74">
                  <path d="M12 2C6.477 2 2 6.477 2 12c0 4.237 2.636 7.855 6.356 9.312-.088-.791-.167-2.005.035-2.868.182-.78 1.172-4.97 1.172-4.97s-.299-.6-.299-1.486c0-1.39.806-2.428 1.81-2.428.852 0 1.264.64 1.264 1.408 0 .858-.545 2.14-.828 3.33-.236.995.5 1.807 1.48 1.807 1.778 0 3.144-1.874 3.144-4.58 0-2.393-1.72-4.068-4.177-4.068-2.845 0-4.515 2.135-4.515 4.34 0 .859.331 1.781.745 2.281a.3.3 0 0 1 .069.288l-.278 1.133c-.044.183-.145.223-.335.134-1.249-.581-2.03-2.407-2.03-3.874 0-3.154 2.292-6.052 6.608-6.052 3.469 0 6.165 2.473 6.165 5.776 0 3.447-2.173 6.22-5.19 6.22-1.013 0-1.965-.525-2.291-1.148l-.623 2.378c-.226.869-.835 1.958-1.244 2.621.937.29 1.931.446 2.962.446 5.523 0 10-4.477 10-10S17.523 2 12 2z" data-id="element-75" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-cream/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-cream/60" data-id="element-76">
          <p data-id="element-77">© 2026 Pure Pulse. All rights reserved.</p>
          <div className="flex gap-4" data-id="element-78">
            <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" alt="Visa" className="h-6 opacity-60" data-id="element-79" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="Mastercard" className="h-6 opacity-60" data-id="element-80" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="PayPal" className="h-6 opacity-60" data-id="element-81" />
          </div>
        </div>
      </div>
    </footer>;
}